export default function () {
  const widgetName = 'ticketsCards';
  const widgetOpts = ticketsCardsOpts;
  const clientPath = SITEBASEURL;
  let windowSize = $(window).width();
  let breakpoint = 800;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (data) {
      $(`#${widgetName} .card-widget-item`).each(function (x) {
        $(this).find('.card-widget-title').remove();
        $(this).find('.buttonwrap').remove();
        $(this).attr('aria-label', data.items[x].Title);

        if (data.items[x].URL !== null && data.items[x].URL.includes(clientPath)) {
          $(this).removeAttr('target');
        }

        if (data.items[x].URL == null) {
          $(this).removeAttr('target');
          $(this).removeAttr('href');
          if (windowSize > breakpoint) {
            $(this).addClass('void-link');
          }
        }
      });

      if (data.items.length == 0) {
        $(`#${widgetName}`).remove();
        $('.tier-3-container .inner-container').remove();
        $('.tier-3-container').css('padding', '6px');
      }
    },
    link: ['all'],
    maxItemsVisible: 4,
    itemsPerPanel: 4,
    hasImages: true,
    lazyLoadImages: true,
    textOverImage: false,
    imageIsBackground: false,
    showDescription: true,
    buyNowButton: false,
    scriptPath: widgetOpts.scriptPath,
  });
}
